var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCertificateSubject24(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.246 8.66667H17.205V6.7619C17.205 4.13333 14.8732 2 12 2C9.12691 2 6.79509 4.13333 6.79509 6.7619V8.66667H5.7541C4.60901 8.66667 3.67212 9.52381 3.67212 10.5714V20.0952C3.67212 21.1429 4.60901 22 5.7541 22H18.246C19.3911 22 20.328 21.1429 20.328 20.0952V10.5714C20.328 9.52381 19.3911 8.66667 18.246 8.66667ZM8.77297 6.7619C8.77297 5.13333 10.2199 3.80952 12 3.80952C13.7801 3.80952 15.2271 5.13333 15.2271 6.7619V8.66667H8.77297V6.7619Z",
    fill: "#212B36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertificateSubject24);
export default __webpack_public_path__ + "static/media/icon_certificate_subject_24.8aa92db41ae13ecc55bdad138e6d6ba4.svg";
export { ForwardRef as ReactComponent };